import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Button, Checkbox, FormControl, FormControlLabel, IconButton, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import { ApiGenerateInvoice, ApiGenerateMasterInvoice, ApiGenerateShopperInvoice, ApiGenerateShopperInvoicePDF, ApiGenerateShopperWiseInvoice, ApiGetGeneratedInvoiceList, ApiGetInvoiceReportList, ApiGetInvoiceStatus, ApiGetShopperList, ApiUpdateBulkStatus } from '../../../apiService/Core/Apicall.tsx'
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { toast } from 'react-toastify';
import { Cancel, Clear, LocalAtm, PictureAsPdf, RampRightOutlined, SettingsBackupRestore } from '@mui/icons-material';
import { Check, Copy } from 'lucide-react';
import details from '../../../assets/images/details.png'
import { useNavigate } from 'react-router-dom';

function PayInvoice() {
    const [selectedShopper, setSelectedShopper] = useState<any>()
    const [searchShopper, setsearchShopper] = useState<any>([])
    const [datalength, setdatalength] = useState<any>(null);
    const [selectedRow, setSelectedRow] = useState<any>([]);
    const [reportlist, setreportlist] = useState<any>([]);
    const [shopperlist, setshopperlist] = useState<any>([]);
    const [page, setPage] = useState(0);
    const [marked, setMarked] = useState<string>('false');
    const [statusList, setStatusList] = useState<any>([]);
    const [status, setStatus] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const navigate = useNavigate()
    const [selectedDate, setSelectedDate] = useState<Date>(new Date());


    // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getgeneratedinvoice = async () => {
        try {
            const data = `?month=${selectedDate?.getMonth() + 1}&year=${selectedDate?.getFullYear()}${selectedShopper ? `&userId=${selectedShopper.userId}` : ''}&isInvoiceChecked=${marked}${status !== 0 ? `&shopperInvoiceStatusId=${status}` : ''}`
            const res = await ApiGetGeneratedInvoiceList(data)
            console.log("Report Data", res.data)
            setreportlist(res.data)
            // setdatalength()
        } catch (error) {
            console.log(error)
        }
    }

    const getShopperList = async () => {
        try {
            const data = `?offset=0${searchShopper?.length > 0 ? `&search=${searchShopper}` : ''}`
            const res = await ApiGetShopperList(data)
            setshopperlist(res.data)
            const defaultselected = (res.data?.filter(item => item.firstName !== ''))
            // setSelectedShopper(defaultselected[0])

        } catch (error) {
            alert(error)
        }
    }
    const getInvoiceStatus = async () => {
        try {
            const data = `?offset=0&limit=20`
            const res = await ApiGetInvoiceStatus()
            setStatusList(res.data)
        } catch (error) {
            alert(error)
        }
    }

    const markSelectedStatus = async (type: string) => {
        if (selectedRow.length > 0) {
            try {
                const data = {
                    shopperInvoiceIds: selectedRow,
                    updateType: type,       // "bulkChecked", "bulkConfirmed"
                    modifiedBy: localStorage.getItem('userRole')
                }
                const res = await ApiUpdateBulkStatus(data)
                toast.success(res.message)
                getgeneratedinvoice()
                setSelectedRow([])
            } catch (error) {
                alert(error)
            }
        }
        else {
            toast.error("Please Select Invoice")
        }

    }

    useEffect(() => {
        getShopperList()
        getInvoiceStatus()
    }, [])

    useEffect(() => {
        getShopperList()
    }, [searchShopper])


    useEffect(() => {
        getgeneratedinvoice()
    }, [selectedDate, selectedShopper, status, marked])


    const handleSelectRow = (index: number) => {
        setSelectedRow((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };



    const ShopperWiseInvoice = async () => {
        const data = `?month=${selectedDate?.getMonth() + 1}&year=${selectedDate?.getFullYear()}`
        try {
            const res = await ApiGenerateShopperWiseInvoice(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Shopper_Wise_Invoice.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }
    const ShopperInvoice = async () => {
        const data = `?month=${selectedDate?.getMonth() + 1}&year=${selectedDate?.getFullYear()}`
        try {
            const res = await ApiGenerateShopperInvoice(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Shopper_Invoice.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }
    const ShopperInvoicePDF = async (shopperInvoiceId,userId) => {
        const data = `?shopperInvoiceId=${shopperInvoiceId}&userId=${userId}`
        try {
            const res = await ApiGenerateShopperInvoicePDF(data);

            const blob = new Blob([res], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            link.download = 'Shopper_Invoice_PDF.pdf';
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url)

        } catch (error) {
            alert(error)
        }
    }

    const GenerateMastreInvoice = async () => {
        const data = `?month=${selectedDate?.getMonth() + 1}&year=${selectedDate?.getFullYear()}`
        try {
            const res = await ApiGenerateMasterInvoice(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Master_Invoice.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }

    return (
        <div>
            <Box sx={{ p: 4 }} style={{ background: "white" }}>
                <Box className='w-100'>
                    <Typography className='text-center' variant='h4'> Pay Invoice</Typography>
                </Box>
                <Box my={3} className='d-flex align-items-center justify-content-between'>
                    <Box className='col-4'>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                        >
                            Airtasker Stats
                        </Button>
                    </Box>
                    <Box className='col-4' sx={{ display: "flex", justifyContent: "center", px: 2 }}>
                        {/* <OliveButton>All Report Status</OliveButton> */}

                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                views={["month", "year"]}
                                label=""
                                value={selectedDate}
                                onChange={(newDate) => newDate && setSelectedDate(newDate)}
                                format="MM/yyyy"
                                sx={{
                                    width: "400px",
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 1,
                                    },
                                }}
                            />
                        </LocalizationProvider>

                        {/* <OliveButton>DOWNLOAD AS XLS</OliveButton> */}
                    </Box>
                    <Box className='d-flex col-4 justify-content-end' gap={1}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={ShopperWiseInvoice}
                        >
                            Export Shopper Wise
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={ShopperInvoice}

                        >
                            Export as Excel
                        </Button>
                    </Box>
                </Box>

                <Box className='d-flex align-items-stretch mt-3' gap={1}>

                    <FormControl size="medium" fullWidth>
                        <label htmlFor="search_shopper" className='mb-0 pl-1' style={{ fontSize: '16px' }}>Search Shopper</label>
                        <Autocomplete
                            id='serach_shopper'
                            disablePortal
                            options={shopperlist?.filter(item => item.firstName !== '')}
                            value={selectedShopper}
                            onInputChange={(event, newInputValue) => { setsearchShopper(newInputValue) }}
                            getOptionLabel={(option: any) => `${option?.firstName} ${option.lastName}`}
                            isOptionEqualToValue={(option: any, value: any) =>
                                option.userId === value.userId || option.emailId === value.emailId
                            }
                            filterOptions={(options, { inputValue }) =>
                                options.filter((option) => {
                                    const fullName = `${option.firstName} ${option.lastName}`.toLowerCase();
                                    const email = option.emailId?.toLowerCase() || '';
                                    const search = inputValue.toLowerCase();
                                    return fullName.includes(search) || email.includes(search);
                                })
                            }
                            onChange={(event, newValue: any) => {
                                setSelectedShopper(newValue)
                            }}
                            // defaultValue={shopperlist?.filter(item => item.firstName !== '')[0]}
                            renderInput={(params) => <TextField {...params} />}
                            size="small"
                        />
                    </FormControl>

                    <FormControl size="small" fullWidth>
                        <label htmlFor="marked" className='mb-0 pl-1' style={{ fontSize: '16px' }}>Marked</label>
                        <Select
                            // className='col-3'
                            id="marked"
                            value={marked}
                            onChange={(e) => setMarked(e.target.value)}
                        >
                            <MenuItem value={'false'} >UnChecked </MenuItem>
                            <MenuItem value={'true'} >Checked </MenuItem>

                        </Select>
                    </FormControl>
                    <FormControl size="small" fullWidth >
                        <label htmlFor="status" className='mb-0 pl-1' style={{ fontSize: '16px' }}>Status</label>
                        <Select
                            // className='col-3'
                            id="status"
                            value={status}
                            onChange={(e) => e && setStatus(Number(e.target.value))}
                        >
                            <MenuItem value={0} >All</MenuItem>
                            {
                                statusList.length > 0 && statusList.map((item, index) => (
                                    <MenuItem value={item?.invoiceStatusId} >{item?.invoiceStatusName}</MenuItem>
                                ))
                            }

                        </Select>
                    </FormControl>



                </Box>
                <Box className='d-flex align-items-center justify-content-between mt-4'>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        size="small"
                        className="table-row-background"
                        style={{ width: "auto" }}
                        onClick={GenerateMastreInvoice}                    >

                        Export Non Invoice Reports
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="table-row-background"
                        style={{ width: "auto" }}
                        onClick={() => { markSelectedStatus('bulkConfirmed') }}
                    >
                        Mark Selected Confirmed
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="table-row-background"
                        style={{ width: "auto" }}
                        onClick={() => { markSelectedStatus('bulkChecked') }}

                    >
                        update BULK(Mark Selected Checked)
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="table-row-background"
                        style={{ width: "auto" }}
                    >
                        Export Checked Shoppers
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="table-row-background"
                        style={{ width: "auto" }}
                    >
                        Mark Checkd as PAID
                    </Button>
                </Box>

                <Box className='w-100 mt-5'>
                    <TableContainer
                        component={Paper}
                        sx={{ mb: 4, border: "1px solid #ccc" }}
                    >
                        <Table>
                            <TableHead sx={{ bgcolor: "#7a7d52" }}>
                                <TableRow>
                                    <TableCell className='text-center' padding="checkbox" sx={{ color: "white" }}>
                                        <FormControlLabel
                                            className='m-0 p-0'
                                            control={
                                                <Checkbox
                                                    indeterminate={
                                                        selectedRow.length > 0 && selectedRow.length < reportlist.length
                                                    }
                                                    checked={
                                                        reportlist.length > 0 && selectedRow.length === reportlist.length
                                                    }
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            // Select all rows
                                                            setSelectedRow(reportlist.map((item) => item?.shopperInvoiceId));
                                                        } else {
                                                            // Deselect all
                                                            setSelectedRow([]);
                                                        }
                                                    }}
                                                />
                                            }
                                            label="BULK"
                                        />
                                    </TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>DOC</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>SOS</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Checked</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Inv#</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Date/Time</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Month</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Shopper</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Copy</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Status</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Total</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Tnx ID</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Tnx Date</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Reject</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Pay</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>PDF</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Details</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    reportlist.length > 0 ? (reportlist.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell className='d-flex align-items-start'>
                                                <Checkbox
                                                    className='px-0 mx-0'
                                                    checked={selectedRow.includes(item?.shopperInvoiceId)}
                                                    onChange={() => { handleSelectRow(item?.shopperInvoiceId) }}
                                                /></TableCell>
                                            <TableCell><Check color='green' /></TableCell>
                                            <TableCell><Clear sx={{ color: 'red' }} /></TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{(item?.isInvoiceChecked) ? 'true' : 'false'}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.shopperInvoiceId}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{new Date(item?.createdOn).toLocaleDateString('en-CA')}
                                                <br />
                                                <span style={{ whiteSpace: 'nowrap' }}>{new Date(item?.createdOn).toLocaleTimeString('en-US', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                    hour12: true, // enables AM/PM
                                                })}</span>
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.month}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.userId?.firstName} {item?.userId?.lastName}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}><Copy /></TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.shopperInvoiceStatusId?.invoiceStatusName}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.totalAmountToPay}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.transactionId}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.transactionDate}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}><SettingsBackupRestore /></TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}><LocalAtm /></TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}><IconButton onClick={()=>{ShopperInvoicePDF(item?.shopperInvoiceId,item?.userId?.userId)}}><PictureAsPdf /></IconButton></TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <IconButton onClick={() => { navigate(`/admin/invoices/invoice-details`, { state: { shopperInvoiceId: item?.shopperInvoiceId } }) }}>
                                                    <Box component='img' className='w-50' src={details}></Box>
                                                </IconButton></TableCell>


                                        </TableRow>
                                    )))
                                        : <TableCell className='text-center' colSpan={18}><Typography>No Data Found</Typography></TableCell>
                                }

                            </TableBody>
                        </Table>

                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={datalength}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Box>
            </Box>
        </div>
    )
}

export default PayInvoice
